import { useState } from 'react';
import { Box, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import userService from '../../services/user_service';
import { useNavigate } from 'react-router-dom';
import userConstants from '../../constants/user_constants';



function AddUser() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState(1);
  const [age, setAge] = useState('')


  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const handleRoleChange = (event) => {
    console.log(event.target.value)
    setRole(event.target.value);
  };

  // Handle for submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      email : email,
      password : password,
      name : username,
      phone : phone,
      age : age,
      role : role,
    }
    const response = await userService.createOneUser(data);

    if (response.data) {
      alert("User created successfully");
      navigate(-1); 
    } else {
      alert("An error occurred while creating the user");
    }
  }

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen User" />
      </Box>

      <Box sx={{ marginLeft:'280px', marginRight:'50px', p: 2 }}>
        <form onSubmit={handleSubmit}>

          {/* Input Email */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Email (Format Email yang benar)"
              value={email}
              onChange={handleEmailChange}
              variant="outlined" 
              inputProps={{ type: 'email' }} 
              title="Gunakan format email yang benar!"
              />
          </Box>

          {/* Input Password */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={handlePasswordChange}
              variant="outlined" 
              />
          </Box>

          {/* Input Username */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Username (maksimal 36 karakter)"
              value={username}
              onChange={handleUsernameChange}
              variant="outlined" 
              inputProps={{ maxLength: 36 }}
              />
          </Box>

          {/* Input Phone Number */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Phone Number (Harus 12 digit angka)"
              value={phone}
              onChange={handlePhoneChange}
              variant="outlined" 
              inputProps={{ maxLength: 12, pattern: "\\d{12}" }}
              title="Nomor Telpon harus 12 digit angka!"
              />
          </Box>

          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Age"
              value={age}
              onChange={handleAgeChange}
              variant="outlined" 
              inputProps={{ maxLength: 3 , pattern: "[1-9][0-9]?[0-9]?"}} 
              />
          </Box>

          {/* Pilih Role */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="role-select-label">Role</InputLabel>
              <Select
                labelId="role-select-label"
                id="role-select"
                value={role}
                onChange={handleRoleChange}
                label="Role"
              >
                <MenuItem value={userConstants.userRoleConstants.GUEST}>Guest</MenuItem>
                <MenuItem value={userConstants.userRoleConstants.MEMBER}>Member</MenuItem>
                <MenuItem value={userConstants.userRoleConstants.PERSONAL_TRAINER}>Personal Trainer</MenuItem>
                <MenuItem value={userConstants.userRoleConstants.CUSTOMER_SERVICE}>Customer Service</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Button type="submit" variant="contained" sx={{ boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white' }}>
            Add User
          </Button>
          <Button variant="contained" sx={{ left:10 , boxShadow: 5, textTransform: 'none', bgcolor: '#FF5630', color: 'white' }}onClick={handleCancel}>Cancel</Button>
        </form>
      </Box></>
  );
}

export default AddUser;